import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import NoData from 'assets/images/UI/no_data.svg'

// Components
import BaseTemplate from "./BaseTemplate";

// Container matching factor analytics page
const Container = styled.div`
  width: 100%;
  min-height: calc(100vh - 200px);
  display: flex;
  flex-direction: column;
  font-family: 'Raleway';
`;

const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 200px;
  margin-bottom: 20px;
`;

// Header row with title and action controls
const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 30px;
  margin-left: -20px;
`;

// Title with icon (matching factor analytics)
const Title = styled.div`
  font-size: 28px;
  font-weight: bold;
  color: #2A3039;
  display: flex;
  align-items: center;
  gap: 10px;
`;

// Action controls on the right side
const ActionControls = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  
  > * {
    display: flex;
    align-items: center;
    margin: 0 !important;
  }
  
  button {
    margin: 0 !important;
  }
`;

// Separator for dividing control groups
const Separator = styled.div`
  width: 1px;
  height: 24px;
  background-color: #E5E7EB;
  margin: 0 4px;
`;

const TitleIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  background: #F8F9FA;
  border-radius: 7px;
  color: #1F2937;
`;

// Zero state message in center
const ZeroStateContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  font-family: "Raleway";
`;

const ZeroStateMessage = styled.div`
  font-size: 16px;
  color: #666D79;
  text-align: center;
  margin-bottom: 40px;
`;

const ZeroStateTemplate = ({
  titleText,
  titleIcon,
  descriptionText,
  actionControls,
  zeroStateMessage = "Create your first analysis to get started",
  ctaRow,
}) => {
  return (
    <Container>
      {/* Header with title and action controls */}
      <HeaderRow>
        <Title>
          {titleIcon && (
            <TitleIconWrapper aria-hidden>
              {titleIcon}
            </TitleIconWrapper>
          )}
          {titleText}
        </Title>

        {actionControls && (
          <ActionControls>
            {actionControls}
          </ActionControls>
        )}
      </HeaderRow>

      {/* Zero state content in center */}
      <ZeroStateContent>
        <ImageWrapper>

          <img src={NoData} style={{ width: 200 }} />
        </ImageWrapper>

        {descriptionText && <ZeroStateMessage>{descriptionText}</ZeroStateMessage>}
        {/* {ctaRow} */}
      </ZeroStateContent>
    </Container>
  );
};

ZeroStateTemplate.propTypes = {
  titleText: PropTypes.string.isRequired,
  titleIcon: PropTypes.node,
  actionControls: PropTypes.node,
  zeroStateMessage: PropTypes.string,
  ctaRow: PropTypes.node,
};

export default ZeroStateTemplate;
export { Separator };
